import React from "react";
import { Banknote, CreditCard, QrCode, Ticket, Wallet, Layers } from "lucide-react";
import { formatarReais } from "../lib/pagamentoPartes";

// Formas usadas no pedido, cada uma com o valor quando são duas ou mais.
// Uma forma só: só o nome (o total já aparece ao lado). `variante`:
//   "card"    — rodapé do card: UMA linha (o card tem altura fixa; o que não
//               couber some no fim e o texto inteiro fica no title de quem usa)
//   "tabela"  — célula da tabela (uma forma por linha)
//   "detalhe" — modal do pedido (uma forma por linha)

const IFood = ({ className }) => (
  <img src="/logo-ifood.png" alt="iFood" className={className} style={{ objectFit: "contain" }} />
);

const ICONES = {
  dinheiro: Banknote,
  cartao: CreditCard,
  cartao_online: CreditCard,
  pix: QrCode,
  pix_online: QrCode,
  vale_alimentacao: Ticket,
  ifood: IFood,
  sem_detalhe: Layers,
};

// Grupo conhecido usa sempre o ícone do sistema — senão o mesmo card misturava
// o emoji da forma cadastrada ("💵 Dinheiro") com o ícone da parte gravada pela
// chave base ("Cartão"). Emoji só na forma própria da loja (Voucher, Nota...).
function Icone({ parte, emojiDe, className }) {
  const Icon = ICONES[parte.chave];
  if (Icon) return <Icon className={`shrink-0 ${className}`} />;
  const emoji = emojiDe?.(parte.forma);
  if (emoji) return <span className="shrink-0 text-xs leading-none">{emoji}</span>;
  return <Wallet className={`shrink-0 ${className}`} />;
}

const ESTILO = {
  card: { caixa: "flex flex-nowrap items-center gap-x-2 min-w-0 overflow-hidden", linha: "text-[11px]", icone: "w-3 h-3" },
  tabela: { caixa: "flex flex-col gap-0.5", linha: "text-sm", icone: "w-4 h-4 text-muted-foreground" },
  detalhe: { caixa: "space-y-0.5", linha: "text-xs text-muted-foreground", icone: "w-3.5 h-3.5" },
};

export default function FormasPagamentoPedido({ partes, variante = "card", emojiDe, e2e }) {
  const estilo = ESTILO[variante] || ESTILO.card;
  const comValor = partes.length > 1;
  if (!partes.length) return <span className={estilo.linha}>—</span>;
  return (
    <div className={estilo.caixa} data-e2e={e2e}>
      {partes.map((p) => (
        // No card (uma linha só) o nome encolhe primeiro e o valor nunca: sem o
        // min-w-0 a parte não passa do "ícone + valor" e não invade a vizinha
        <span key={p.chave} className={`flex items-center gap-1 whitespace-nowrap ${variante === "card" ? "" : "min-w-0"} ${estilo.linha}`}
          data-e2e="forma-pagamento" data-chave={p.chave}>
          <Icone parte={p} emojiDe={emojiDe} className={estilo.icone} />
          <span className={variante === "card" ? "truncate" : ""}>{p.nome}</span>
          {comValor && <span className="font-semibold shrink-0">{formatarReais(p.valor)}</span>}
        </span>
      ))}
    </div>
  );
}
